import { Emitter, Event } from "../../../../../features/event-emitter"
import { VatCondition } from "../../../../administration"
import { useCustomerService } from "../../../services/customerService"

export const useActions = () => {
    const { updateCustomer } = useCustomerService()
    
    const updateCustomerVatCondition = async (
        customerId: string,
        vatCondition: VatCondition
    ) => {
        Emitter.emit(Event.DB_SUBMIT)
        const customerData = {
            id: customerId,
            vatCondition
        }
        const updatedCustomer = await updateCustomer(customerData)
        Emitter.emit(Event.DB_SUBMIT_DONE, false, false)

        return updatedCustomer
    }

    return {
        updateCustomerVatCondition
    }
}
